module.exports = __webpack_public_path__ + "img/vertical_2_1_6000.2aca6919.png";